import type { Invoice, InvoiceDetail } from '@faktorplus/shared';

export interface ProjectLabel {
  text: string;
  /** True when there is no real project behind the label. */
  isPlaceholder: boolean;
}

/**
 * How an invoice's project reads in a list.
 *
 * "Not yet assigned" and "deliberately booked as company overhead" are
 * different facts. Rendering both as "koszt ogólny" hid exactly the invoices
 * the system exists to surface — the PRD tracks unassigned invoices as a
 * success metric, so they must be visible at a glance.
 */
export function projectLabel(invoice: Invoice | InvoiceDetail): ProjectLabel {
  if (invoice.allocations.length === 0) {
    return { text: '— nieprzypisana', isPlaceholder: true };
  }

  const projectName = invoice.allocations[0]?.projectName;
  return projectName
    ? { text: projectName, isPlaceholder: false }
    : { text: '— koszt ogólny', isPlaceholder: true };
}

export function managerLabel(invoice: Invoice | InvoiceDetail): string {
  return invoice.allocations[0]?.managerName ?? '—';
}
